module.exports = __webpack_public_path__ + "img/trash.658d26a8.svg";